import { useEffect, useState } from "react"

function remaining(target) {
  const ms = Math.max(0, target - Date.now())
  return {
    d: Math.floor(ms / 86_400_000),
    h: Math.floor((ms % 86_400_000) / 3_600_000),
    m: Math.floor((ms % 3_600_000) / 60_000),
    s: Math.floor((ms % 60_000) / 1_000),
  }
}

// Time left until enrollment closes, ticking each second. Null when no close
// date is set (enrollment open indefinitely) or the date is unreadable, so
// callers render no countdown at all.
export function useCountdown(closesAt) {
  const target = closesAt ? new Date(closesAt).getTime() : NaN
  const valid = !Number.isNaN(target)
  const [left, setLeft] = useState(() => (valid ? remaining(target) : null))

  useEffect(() => {
    if (!valid) {
      setLeft(null)
      return undefined
    }
    setLeft(remaining(target))
    const id = setInterval(() => setLeft(remaining(target)), 1000)
    return () => clearInterval(id)
  }, [target, valid])

  return valid ? left : null
}

export function CountdownText({ left }) {
  const pad = (n) => String(n).padStart(2, "0")
  return (
    <span className="tabular-nums">
      <b className="text-foreground">{pad(left.d)}</b>d <b className="text-foreground">{pad(left.h)}</b>h{" "}
      <b className="text-foreground">{pad(left.m)}</b>m <b className="text-foreground">{pad(left.s)}</b>s
    </span>
  )
}
